import type React from 'react';
import styles from './LoadingSkeleton.module.css';

export const MessageSkeleton: React.FC = () => {
  return (
    <div className={styles.skeleton}>
      <div className={styles.line} />
      <div className={`${styles.line} ${styles.lineMedium}`} />
      <div className={`${styles.line} ${styles.lineShort}`} />
    </div>
  );
};

export const ConversationSkeleton: React.FC = () => {
  return (
    <div className={styles.skeleton}>
      <div className={`${styles.line} ${styles.lineMedium}`} />
      <div className={`${styles.line} ${styles.lineShort}`} />
    </div>
  );
};

/**
 * Loading Skeleton for Conversation List
 */
export const ConversationListSkeleton: React.FC<{ count?: number }> = ({ count = 5 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <ConversationSkeleton key={index} />
      ))}
    </>
  );
};

/**
 * Loading Skeleton for Chat Messages
 */
export const MessageListSkeleton: React.FC<{ count?: number }> = ({ count = 3 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <MessageSkeleton key={index} />
      ))}
    </>
  );
};
